import { render, staticRenderFns } from "./simulador.html?vue&type=template&id=0f9fa10a&scoped=true&"
import script from "./simulador.js?vue&type=script&lang=js&"
export * from "./simulador.js?vue&type=script&lang=js&"
import style0 from "./simulador.scss?vue&type=style&index=0&id=0f9fa10a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fa10a",
  null
  
)

export default component.exports